/**
 * Click-to-add on upsell cards whose button is hidden.
 *
 * Hiding the button left the card as a plain product link, so a click sent the
 * shopper to the product page - away from the checkout they were halfway
 * through. HexClad's cards add straight to the cart instead.
 *
 * The button is still in the DOM, just not shown, so the card forwards the
 * click to it and every bit of the theme's quick-add behaviour is kept:
 * variant handling, the loading state, the error message, the cart refresh.
 */
(() => {
  const SELECTOR = '.drawer--cart-upsell-nobtn .card--related';

  const onClick = (event) => {
    const card = event.target.closest(SELECTOR);
    if (!card) return;

    // Let a real control inside the card do its own job
    if (event.target.closest('button, input, select, [role="button"]')) return;

    // A product needing a variant choice gets .js-quick-add; one that does not
    // gets a plain submit button inside its own form. Either is fine to click;
    // an <a> is not - that is the fallback link to the product page, which is
    // exactly where this is trying not to send anyone.
    const addBtn =
      card.querySelector('.js-quick-add') ||
      card.querySelector('form button:not([type="button"])');
    if (!addBtn || addBtn.tagName !== 'BUTTON' || addBtn.disabled) return;

    event.preventDefault();
    addBtn.click();
  };

  document.addEventListener('click', onClick);
})();
